'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setConfig = setConfig;
exports.getConfig = getConfig;

var _utils = require('./utils');

var COOKIE = {
  check: true,
  key: {
    ai: 'Valgrind-AI',
    au: 'Valgrind-AU'
  },
  domain: null
};

var ENVIRONMENTS = {
  mock: {
    host: function host() {
      return 'http://localhost:5000';
    },
    apiKey: null,
    cookie: {
      check: false
    }
  },
  development: {
    host: function host(domain) {
      if (domain === 'serasaconsumidor.com.br') {
        return 'https://apigw-portal-hml.ecsbr.net/v1';
      }

      return 'https://api-auth.serasa.dev/v1';
    },
    apiKey: 'KLZAVgYVU58DfvpbCUeTd1ojj3CIVkn4awJJyrRa',
    cookie: {
      check: false,
      domain: null
    }
  },
  homologation: {
    host: function host(domain) {
      if (domain === 'serasaconsumidor.com.br') {
        return 'https://apigw-portal-hml.ecsbr.net/v1';
      }

      return 'https://api-auth.serasa.dev/v1';
    },
    apiKey: 'KLZAVgYVU58DfvpbCUeTd1ojj3CIVkn4awJJyrRa'
  },
  production: {
    host: function host(domain) {
      if (domain === 'serasaconsumidor.com.br') {
        return 'https://apigw-portal-prd.ecsbr.net/v1';
      }

      return 'https://api-auth.serasa.com.br/v1';
    },
    apiKey: 'LFGO3deJs38Pr0n5DLFVL52YNcl2vUjV6aXFTe0j'
  }
};

var config = null;

function setConfig() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$environment = _ref.environment,
      environment = _ref$environment === undefined ? 'development' : _ref$environment,
      applicationId = _ref.applicationId,
      host = _ref.host,
      domain = _ref.domain;

  config = _extends({}, ENVIRONMENTS[environment]);
  config.environment = environment;
  config.domain = (0, _utils.getDomain)(domain);
  config.host = host || config.host(config.domain);
  config.applicationId = applicationId || undefined;
  config.cookie = _extends({}, COOKIE, {
    domain: config.domain
  }, config.cookie || {});

  return config;
}

function getConfig() {
  return config;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/bifrost/build/config.js
// module id = 33
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38